import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { estimatePermissionRoles, mediaAdmin } from 'src/app/helpers/enums/role-type.enum';
import { AuthService } from 'src/app/services/auth/auth.service';
import { IsDeviceOnlineService } from 'src/app/services/is-online/is-online.service';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { SidebarState } from 'src/app/state/sidebar.state';

@Component({
  selector: 'app-vam',
  templateUrl: './vam.component.html',
  styleUrls: ['./vam.component.scss']
})
export class VamComponent implements OnInit {
  public mediaAdmin: string[] = mediaAdmin;
  public isQueryParams: boolean = false;
  public userData: string = null;
  public role: string = null;
  public dmsAuth: Object = {};
  public isDisplay: any;
  public accessToken: any;
  public vehicleId: any;
  public accessRole: any;
  public estimatePermission: string[] = estimatePermissionRoles();
  public subscriptions: Subscription[] = [];

  isDeviceOnline = false;
  storedDatabaseVersion: number = 0.0;
  isEvaluatorLoggedIn = false;
  primaryColor = '#3490dc';

  // start
  public accessToken2: string = '';
  public vehicleId2: string = '';
  public bodyTypeId2: string = '';
  public reportUrl = '';

  constructor(
    public location: Location,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public sharedService: SharedService,
    public sidebar: SidebarState,
    public localeService: LocaleService,
    private readonly _isDeviceOnline: IsDeviceOnlineService
  ) {
    if (
      activatedRoute.snapshot.queryParams.access_token &&
      activatedRoute.snapshot.queryParams.vehicle_id &&
      activatedRoute.snapshot.queryParams.role
    ) {
      this.sharedService.setQueryParamCheck = true;
      this.localeService.langSetter = activatedRoute.snapshot.queryParams.lang;
      this.dmsAuth = {
        token: activatedRoute.snapshot.queryParams.access_token,
        // token: this.activatedRoute.snapshot.queryParamMap.get("access_token"),
        user: {
          user_data: {
            role: activatedRoute.snapshot.queryParams.role
            // role: this.activatedRoute.snapshot.queryParamMap.get("role"),
          }
        }
      };

      localStorage.setItem('user', JSON.stringify({ ...this.dmsAuth }));
      this.authService.userSubject.next({ ...this.dmsAuth });
      this.sharedService.setVehicleId = activatedRoute.snapshot.queryParams.vehicle_id;
    }

    this.isEvaluatorLoggedIn = authService.userData.user.user_data.role === 'evaluator';

    this.getUserData();
    let currentUrl = router.url;
    if (currentUrl.match('/commonrating')) {
      this.isDisplay = false;
    } else {
      this.isDisplay = true;
    }
  }

  ngOnInit(): void {
    const rawUserInfo = localStorage.getItem('user');
    this.vehicleId2 = localStorage.getItem('vehicleId');

    if (rawUserInfo) {
      this.accessToken2 = JSON.parse(rawUserInfo)?.['token'];
    }

    this._isDeviceOnline.networkStatus$.subscribe({
      next: (value) =>
        value === 'online' ? (this.isDeviceOnline = true) : (this.isDeviceOnline = false)
    });

    this.isQueryParams = this.sharedService.getQueryParamCheck;
    this.accessToken = this.activatedRoute.snapshot.queryParamMap.get('access_token');
    this.vehicleId = this.activatedRoute.snapshot.queryParamMap.get('vehicle_id');
    this.accessRole = this.activatedRoute.snapshot.queryParamMap.get('role');

    this.sharedService.vinInformation.subscribe((res) => {
      if (res?.['drive_type_id']?.['id']) {
        this.bodyTypeId2 = res['body_type_id']['id'];
      }
    });

    this.storedDatabaseVersion = Number(localStorage.getItem('pwa-local-database-version'));
  }

  openReport(event: MouseEvent) {
    event.preventDefault();

    const currentParams = this.activatedRoute.snapshot.queryParams;

    const queryParams: Record<string, string> = {};

    if (currentParams.access_token) {
      queryParams.access_token = currentParams.access_token;
    }

    if (currentParams.vehicle_id) {
      queryParams.vehicle_id = currentParams.vehicle_id;
    }

    if (currentParams.role) {
      queryParams.role = currentParams.role;
    }

    // this.router.navigate(['/report'], { queryParams });

    const urlTree = this.router.createUrlTree(['/report'], { queryParams });
    this.reportUrl = this.router.serializeUrl(urlTree);

    // const isInIframe = window.self !== window.top;

    window.open(this.reportUrl, '_blank', 'noopener');

    // if (isInIframe) {
    //   // ✅ iframe → same window navigation
    //   this.router.navigate(['/report']);
    // } else {
    //   // ✅ browser tab → open new tab

    // }
  }

  getUserData() {
    const authSub = this.authService.user.subscribe((res) => {
      let user: any = res && res.user ? res.user : null;

      this.userData = user ? user.user_data : null;
      this.role = user && user.user_data ? user.user_data.role : 'evaluator';
    });

    this.subscriptions.push(authSub);
  }

  // Hovering effect on the header options in vam page
  hoverShifter(event) {
    let target = event.currentTarget;
    const shiftElem: HTMLElement = document.querySelector('.activeShift');
    const width = target.getBoundingClientRect().width;
    const height = target.getBoundingClientRect().height;
    const left = target.getBoundingClientRect().left;
    const top = target.getBoundingClientRect().top;

    shiftElem.style.visibility = `visible`;
    shiftElem.style.transform = `none`;
    shiftElem.style.width = `${width}px`;
    shiftElem.style.height = `${height}px`;
    shiftElem.style.left = `${left}px`;
    shiftElem.style.top = `${top}px`;
  }

  hoverShiftLeave() {
    const target: any = document.querySelector('.activeShift');
    target.style.visibility = `hidden`;
  }

  logout() {
    this.authService.setStatus({ status: true }).subscribe();
    this.authService.Logout();
    this.router.navigate(['/']);
  }
  displayNavBar() {
    this.router.navigate(['/commonrating']);
    this.isDisplay = false;
  }

  goToConnectivityTestRoute() {
    this.router.navigate(['/connectivity-test']);
  }
}
